exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-product-order-performance-container[data-v-edebc3f8]{color:#363636}.modal-title[data-v-edebc3f8]{font-size:20px;font-weight:700;margin-bottom:36px}.c-status[data-v-edebc3f8]{width:10px;height:10px;border-radius:100%;margin:0 6px 0 8px}.c-gray[data-v-edebc3f8]{background-color:#b6becb}.c-primary[data-v-edebc3f8]{background-color:#ff5722}.c-green[data-v-edebc3f8]{background-color:#75c791}.table-content[data-v-edebc3f8],.table-title[data-v-edebc3f8]{text-align:center;font-size:13px}.table-title[data-v-edebc3f8]{color:#787878}.table-content[data-v-edebc3f8]{color:#363636}", ""]);

// exports
